export { default } from './RatingsCell';
